import { __extends } from "tslib";
import { AppState, AppNavigator } from '@wix/answers-api';
import ticketPageIcon from '../../icons/ticket-page.svg';
import * as React from 'react';
import { Icon } from '@wix/answers-ui-libby';
var TicketContextView = /** @class */ (function (_super) {
    __extends(TicketContextView, _super);
    function TicketContextView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isStatsOpen: false
        };
        _this.compTranslate = function (key, params) {
            if (params === void 0) { params = {}; }
            return _this.props.translate("ticket.".concat(key), params);
        };
        _this.stopClickPropagation = function (e) {
            e.stopPropagation();
        };
        return _this;
    }
    TicketContextView.prototype.render = function () {
        var props = this.props;
        var compTranslate = this.compTranslate;
        var ticketContext = props.contextData ? props.contextData.ticketContext : null;
        var ticketId = ticketContext ? ticketContext.ticket.id : '';
        var manageTicketUrl = AppNavigator.getAppLink(AppState.HD_TICKET, ticketId);
        return ticketContext ? (React.createElement("div", { className: 'ticket-context-container' },
            React.createElement("a", { className: 'ticket-page-link', href: manageTicketUrl, target: '_blank', onClick: this.stopClickPropagation },
                React.createElement(Icon, { icon: ticketPageIcon }),
                compTranslate('link')))) : null;
    };
    return TicketContextView;
}(React.PureComponent));
export { TicketContextView };
//# sourceMappingURL=ticket-context-view.comp.js.map